import React, { Component } from "react";

import { withFilterCars } from "../../../shared/containers/containerFilterCars";
import MultiSelects from "../../../shared/items/contols/multiSelect";
import FilterCarsItems from "./static.filterCarsItems";

import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import Preloader from "../../../shared/items/static/preloader";

class CarWinterCompanyFilter extends Component {
  componentDidMount() {
    const { onGetWinterAreasSimple, filterCarsListItems } = this.props;

    if (filterCarsListItems._currentWintrerCompanies === undefined || filterCarsListItems._currentWintrerCompanies.length === 0) {
      onGetWinterAreasSimple();
    }
  }

  render() {
    const { onHandleChangeStore, filterCarsListItems } = this.props;
    const name = FilterCarsItems.winterCompanies.name;

    if (filterCarsListItems._currentWintrerCompanies !== undefined && filterCarsListItems._currentWintrerCompanies.length === 0) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <MultiSelects
        name={name}
        valueStore={filterCarsListItems}
        options={filterCarsListItems._currentWintrerCompanies}
        handleChange={onHandleChangeStore.bind(this, "winterCompanies")}
        placeholder="Выберите компанию"
      />
    );
  }
}

export default withWinterMaintence(withFilterCars(CarWinterCompanyFilter));
